module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"hope-and-tarot","short_name":"hopeandtarot","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/images/hope-favicon.png","cache_busting_mode":"name","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"6571cf5066b5ee26cfbf5715f3b998f4"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
